import { Navigate } from 'react-router-dom';

import { MLB_MARKET_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';

export const Market = () => {
  return <Navigate to={MLB_MARKET_INSTANT_BUY} />;
};

export default Market;
